var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3012_18508)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6 7.3v12.835c0 2.215 1.283 3.655 3.599 3.655h1.809s.21 1.676-.455 4.26l-.013.05c-.07.259-.26.952.204 1.084.216.062.489.03.761-.14.112-.07.576-.354 1.136-.697.999-.612 2.303-1.411 2.453-1.511.674-.45 4.475-3.046 4.475-3.046h11.244c2.14 0 3.587-1.45 3.587-3.65V7.3c0-2.386-1.195-3.7-3.55-3.7H5.205C2.922 3.6 1.6 5.135 1.6 7.3Zm7.2 8.98a2.25 2.25 0 0 0 2.25-2.25v-.091a2.25 2.25 0 1 0-4.5 0v.092a2.25 2.25 0 0 0 2.25 2.25Zm14.4 0a2.25 2.25 0 0 0 2.25-2.25v-.091a2.25 2.25 0 1 0-4.5 0v.092a2.25 2.25 0 0 0 2.25 2.25Zm-4.95-2.25a2.25 2.25 0 1 1-4.5 0v-.091a2.25 2.25 0 1 1 4.5 0v.092Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3012_18508"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0 0h32v32H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chat.a55ec2020fb4e0c7165485bda9733bf2.svg";